import { render, staticRenderFns } from "./WhatsappProfileEdit.vue?vue&type=template&id=45a11492"
import script from "./WhatsappProfileEdit.vue?vue&type=script&lang=js"
export * from "./WhatsappProfileEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports